<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
  <path
    data-player="true"
    fill="#808080"
    d="M256.6,496A239.364,239.364,0,0,0,425.856,87.379,239.364,239.364,0,0,0,87.344,425.892,237.8,237.8,0,0,0,256.6,496Zm0-446.729c114.341,0,207.365,93.023,207.365,207.364S370.941,464,256.6,464,49.236,370.977,49.236,256.635,142.259,49.271,256.6,49.271Z"
  />
</svg>
